import { render, staticRenderFns } from "./JobDetailsPage.vue?vue&type=template&id=31fd5595&scoped=true"
import script from "./JobDetailsPage.vue?vue&type=script&lang=js"
export * from "./JobDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./JobDetailsPage.vue?vue&type=style&index=0&id=31fd5595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fd5595",
  null
  
)

export default component.exports